import { render } from "./BaseDropdownMultiple.vue?vue&type=template&id=bfd9eeb2&scoped=true"
import script from "./BaseDropdownMultiple.vue?vue&type=script&lang=ts"
export * from "./BaseDropdownMultiple.vue?vue&type=script&lang=ts"

import "./BaseDropdownMultiple.vue?vue&type=style&index=0&id=bfd9eeb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bfd9eeb2"

export default script